"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyLinkPanel = void 0;
var _mui = require("@ori-ui/mui");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _CopyLink = require("../components/CopyLink");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _jsxRuntime = require("react/jsx-runtime");
const CopyLinkPanel = props => {
  (0, _logger2.logDebug)('Rendering CopyLinkPanel.tsx ...', props);
  const childLogger = _logger2.mainLogger.createChild('CopyLinkPanel');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
    areaName: "CopyLinkPanel-boundary",
    logger: childLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Checkout,
        project: _constants.APP_NAME,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CopyLink.CopyLink, {
          ...props
        })
      })
    })
  });
};
exports.CopyLinkPanel = CopyLinkPanel;
